module.exports = __webpack_public_path__ + "static/media/acc-icon2.40e55156.svg";